/**
 * Display label for a book level.
 * ORG books use continuous Level N only; COMPANY keeps the free-text name.
 */
export function getLevelDisplayLabel({
  bookType,
  levelNumber,
  name,
  index,
} = {}) {
  if (bookType === "ORG") {
    if (levelNumber != null) return `Level ${levelNumber}`;
    if (index != null) return `Level ${index + 1}`;
    return name || "";
  }
  if (name) return name;
  if (index != null) return `Level ${index + 1}`;
  if (levelNumber != null) return `Level ${levelNumber}`;
  return "";
}

export function isOrgBookType(type) {
  return type === "ORG";
}
